const text = [
    `I am Michael Newman, a full stack web developer pivoting from a nearly 20 year career as an analyst and project manager. I am experienced in React, JavaScript, and Ruby including Rails and ActiveRecord. I also have familiarity in a number of other languages.`,
    
    `I have a passion for user-centered design and over 15 years experience in IT.`]

export default text